import React from 'react'
import Document from './Document'
import { AttachmentData, AttachmentStatus, AttachmentType, WithRequired } from '../../../../../../../../@types/types'
import UploadingList from '../common/UploadingList'

export interface DocumentListProps {
  screenId: string
  attachmentData: AttachmentData[]
}

export const DocumentList: React.FC<DocumentListProps> = ({ screenId, attachmentData }) => {
  return (
    <>
      <PersistedList attachments={attachmentData} screenId={screenId} />
      <UploadingList attachments={attachmentData} attachmentType={AttachmentType.DOCUMENT} />
    </>
  )
}

function PersistedList({ attachments, screenId }: { attachments: AttachmentData[]; screenId: string }) {
  return attachments
    .filter((it) => it.state === AttachmentStatus.PERSISTED && it.attachmentType !== AttachmentType.VIDEO)
    .map((it, index) => isDocumentType(it) && DocumentAttachment(screenId, it, index))
}

function isDocumentType(it: AttachmentData) {
  return it.attachmentType === AttachmentType.DOCUMENT
}

function DocumentAttachment(screenId: string, it: AttachmentData, index: number) {
  return (
    <Document
      screenId={screenId}
      key={it.attachment?.id}
      data={it as WithRequired<AttachmentData, 'attachment'>}
      index={index}
    />
  )
}

export default DocumentList
